/** Canonical annual business turnover bands (stored values + GBP display). */
export const BUSINESS_TURNOVER_OPTIONS = [
  {
    value: "0-100k",
    label: "£0 – £100,000",
    labelKey: "connections.turnover.0_100k",
  },
  {
    value: "100k-250k",
    label: "£100,000 – £250,000",
    labelKey: "connections.turnover.100k_250k",
  },
  {
    value: "250k-500k",
    label: "£250,000 – £500,000",
    labelKey: "connections.turnover.250k_500k",
  },
  {
    value: "500k-1m",
    label: "£500,000 – £1m",
    labelKey: "connections.turnover.500k_1m",
  },
  {
    value: "1m-5m",
    label: "£1m – £5m",
    labelKey: "connections.turnover.1m_5m",
  },
  {
    value: "5m-10m",
    label: "£5m – £10m",
    labelKey: "connections.turnover.5m_10m",
  },
  {
    value: "10m+",
    label: "£10m+",
    labelKey: "connections.turnover.10m_plus",
  },
] as const;

export type BusinessTurnoverValue =
  (typeof BUSINESS_TURNOVER_OPTIONS)[number]["value"];

/** Map stored turnover value to a GBP label (falls back gracefully). */
export function formatBusinessTurnoverGbp(
  value?: string | null,
  translate?: (key: string) => string,
): string {
  const raw = (value ?? "").trim();
  if (!raw) return "";

  const match = BUSINESS_TURNOVER_OPTIONS.find(
    (o) => o.value.toLowerCase() === raw.toLowerCase(),
  );
  if (match) {
    return translate ? translate(match.labelKey) : match.label;
  }

  // Legacy connection filter values
  const legacy: Record<string, string> = {
    "0-100k": "£0 – £100k",
    "100k-500k": "£100k – £500k",
    "500k-1m": "£500k – £1m",
    "1m-5m": "£1m – £5m",
    "5m-10m": "£5m – £10m",
    "10m+": "£10m+",
  };
  const legacyLabel = legacy[raw.toLowerCase()];
  if (legacyLabel) return legacyLabel;

  if (/£|\bgbp\b/i.test(raw)) return raw;
  return `£${raw}`;
}
